
  import {Component, Prop, Watch} from 'vue-property-decorator';

  import BookingUser from '@/bookings/components/BookingUser.vue';
  import { Booking } from '@/bookings/interfaces';

  import BaseService from './BaseService.vue';
  import LoginModal from './LoginModal.vue';


  @Component({components: {LoginModal, BookingUser}})
  export default class Account extends BaseService {
    @Prop() fromAppBar!: boolean;

    sheet = false;

    bookingDialog = false;

    dataBooking: Booking[] | null = null

    mybooking = false


    @Watch('$store.state.user.userId')
    updateDialog(): void {
      this.login();
    }

    updateBookingList(): void{
    if (this.accessToken)
      this.getBookingList(this.email)
  }
  }
